import React from 'react';

import { motion } from 'framer-motion';

interface ModernFeatureListProps {
  features: string[];
  className?: string;
  iconColor?: string;
  textColor?: string;
  animated?: boolean;
}

export const ModernFeatureList: React.FC<ModernFeatureListProps> = ({
  features,
  className = '',
  iconColor = 'bg-blue-600',
  textColor = 'text-gray-600',
  animated = true,
}) => {
  return (
    <div className={`space-y-2 ${className}`}>
      {features?.map((feature, index) => {
        const FeatureComponent = animated ? motion.div : 'div';

        return (
          <FeatureComponent
            key={index}
            className={`flex items-center text-sm ${textColor}`}
            initial={animated ? { opacity: 0, x: -10 } : undefined}
            animate={animated ? { opacity: 1, x: 0 } : undefined}
            transition={animated ? { duration: 0.3, delay: index * 0.1 } : undefined}
          >
            <div className={`w-1.5 h-1.5 ${iconColor} rounded-full mr-2`}></div>
            {feature}
          </FeatureComponent>
        );
      })}
    </div>
  );
};

export default ModernFeatureList;
